import JSONAPISerializer from '@ember-data/serializer/json-api';

export default JSONAPISerializer.extend({
  attrs: {
    completePercent: {serialize: false},
  },

  /**
   * @inheritDoc
   */
  serialize(snapshot, options) {
    let json = this._super(snapshot, options);

    if (!snapshot.attr('conflictReporting')) {
      //if we do NOT have conflict reporting set when serializing, don't bother sending these down to the server.

      delete json.data.attributes['cr-hostile-env-training'];
      delete json.data.attributes['cr-hostile-env-training-val'];
      delete json.data.attributes['cr-citizenships'];
      delete json.data.attributes['cr-email'];
      delete json.data.attributes['cr-first-aid-training'];
      delete json.data.attributes['cr-first-aid-training-val:'];
      delete json.data.attributes['cr-full-name'];
      delete json.data.attributes['cr-insurance'];
      delete json.data.attributes['cr-insurance-val'];
      delete json.data.attributes['cr-local-phone'];
      delete json.data.attributes['cr-phone'];
      delete json.data.attributes['cr-relationship'];
      delete json.data.attributes['cr-skype'];
    }

    return json;
  }
});
